import { render, staticRenderFns } from "./ComplaintCompleted.vue?vue&type=template&id=eac7438a&scoped=true&"
import script from "./ComplaintCompleted.vue?vue&type=script&lang=js&"
export * from "./ComplaintCompleted.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintCompleted.vue?vue&type=style&index=0&id=eac7438a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac7438a",
  null
  
)

export default component.exports